import { gql, useMutation } from '@apollo/client';
import { Pda } from './components/Pda';
import { Header } from './components/Header';
import { HandleScanEventResult, VehicleRelatedScanComponent } from './components/VehicleRelatedScanComponent';
import { t } from '../../i18n';


const HANDLE_WHS_LOADING_SCAN_EVENT = gql`
mutation HandleWhsLoadingScanEvent($licensePlate: String!, $barCode: String!) {
    success: handleWhsLoadingScanEvent(licensePlate: $licensePlate, barCode: $barCode)
}
`

const PageBody = () => {

  const [handleWhsLoadingScanEvent] = useMutation<HandleScanEventResult>(HANDLE_WHS_LOADING_SCAN_EVENT);

  const handleScanEvent = async (value1: string, value2: string): Promise<HandleScanEventResult> => {
    const {data} = await handleWhsLoadingScanEvent({ variables: { licensePlate: value1, barCode: value2 } });
    return {success: data?.success || false};
  };

  return (
    <VehicleRelatedScanComponent
      value1Placeholder={t('pda.pages.loading.licensePlate')}
      value2Placeholder={t('pda.pages.loading.bagCodeTrackingNo')}
      value1ColumnTitle={t('pda.pages.loading.licensePlate')}
      value2ColumnTitle={t('pda.common.bagPackage')}
      isCheckBarCodeValid={true}
      handleScanEvent={handleScanEvent}
    />
  );
}

export default function LoadingPage() {
  return (
    <div className="w-full h-full flex flex-col gap-2 p-2">
      <Header title={t('pda.pages.loading.loadingScan')} />
      <Pda />
      <PageBody />
    </div>
  );
}